import React, { useContext, useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment-timezone";

import { baseUrl, INDIAN_CURRENCY } from "../../config/config";
import AuthContext from "../../contexts/AuthContext";
import closeIcon from "../../assets/img/EventDashoardLogo/closeIcon.svg"
import { EVENT_PLAN } from "../../config/constants";
import KonfhubButton from "../../revampComponents/Atom/Buttons/KonfhubButton";
import TippyIcon from "../../revampComponents/Atom/TippyIcon";
import {
	LiveStatusIcon,
	PastStatusIcon,
	LinkPreviewIcon,
	CloneEventIcon,
	UpcomingStatusIcon,
	ShareIcon,
} from "./../../assets/img/Header/index";
import ProfileDropDown from "./ProfileDropDown";
import SwitchEventDropDown from "./SwitchEventDropDown";
import Banner from "./Banner";
import SwitchApplications from "./SwitchApplications";
import MyCommunity from "./MyCommunity/MyCommunity";
import KonfhubWhiteLogo from "../../assets/pages/Section/ManageEvents/KonfhubWhiteLogo.svg";
import KonfhubWhiteLogoChristmas from "../../assets/img/KonfhubLogos/PerFestival/Christmas/logo-white.svg";
import PricingPlanModal from "./PricingPlanModal";
import EventLimits from "./EventLimits";
import { getStripeAccount } from "../../revampCRUD/stripe.crud";
import { getTapAccount } from "../../revampCRUD/tap.crud";
import CloneEventModal from "./CloneEvent/CloneEventModal";
import MaintenanceBanner from "./MaintenanceBanner";
import AnimatedLogo from "../../components/common/basic/AnimatedLogo";
import { eventStatus } from "../../Utils/helpers";
import { CustomModal } from "../../revampComponents/Atom/Modals";
import ShareModal from "./ShareModal";
import ShareQuickButton from "../../revampComponents/Share/ShareQuickButton";
import { SuperAdmins } from "../../config/SuperAdmins";
import WhatsNewPopup from "./WhatsNewPopup";

const Header = props => {
	const { expandedSection, setExpandedSection, isManageEventsPage = false } = props;

	const { eventInfo } = props;
	const communityRef = useRef();
	const [openCloneModal, setOpenCloneModal] = useState(false);
	const [openShareModal, setOpenShareModal] = useState(false);
	const [communityButtonLoading, setCommunityButtonLoading] = useState(false);
	const [hasStripeOrTap, setHasStripeOrTap] = useState(false); //only for international events
	const [isLoadStripeOrTap, setIsLoadStripeOrTap] = useState(false); //only for international events
	const [showMaintenanceBanner, setShowMaintenanceBanner] = useState(false);

	const setSidebarIsOpen = useDispatch();
	const history = useHistory();
	const { eventId } = useParams();
	const { eventInfo: eventData, organiserDetails, user, setEventDetails } = useContext(AuthContext);

	const eventDetails = props?.prefeventinfo;
	const reloadApi = props?.getAllDetails;
	const isInternational = props?.eventInfo?.currency_name !== INDIAN_CURRENCY;
	const isNotCreator = props?.eventInfo?.organiser_role_id !== 1;
	const isPaidEvent = props?.eventInfo?.is_free ? false : true;
	const isBankDetailsAdded = props?.eventInfo?.has_bank_details ? true : false;
	const isKYCVerified = eventData?.organiser_kyc_verified ? true : false;
	const isSettlementsDisabled = props?.eventInfo?.disable_settlements ? true : false;

	const checkIfStripeOrTapConnected = async () => {
		setIsLoadStripeOrTap(true);
		try {
			await getStripeAccount(eventId);
			setHasStripeOrTap(true);
			setIsLoadStripeOrTap(false);
		} catch (err) {
			try {
				await getTapAccount(eventId);
				setHasStripeOrTap(true);
				setIsLoadStripeOrTap(false);
			} catch (err) {
				console.log(err);
				setIsLoadStripeOrTap(false);
			}
		}
	};

	useEffect(() => {
		if (isInternational && eventId) checkIfStripeOrTapConnected();
	}, [isInternational, eventId]);

	const callCommunityFunction = () => {
		communityRef?.current?.goToMyCommunity();
	};

	const handleCommunityStateChange = newChildState => {
		setCommunityButtonLoading(newChildState);
	};

	const getPlanName = (planId) => {
		return Object.keys(EVENT_PLAN).find(key => EVENT_PLAN[key] === planId) || "";
	};

	const planBtnContent = () => {
		const planName = eventInfo?.event_plan ? getPlanName(eventInfo.event_plan) : "";

		return (
			<span>
				<span className="create_new_event">Plan: </span>
				{planName}
			</span>
		);
	};

	// Function to check if the current date and time is between 28 October 12:01 AM and 3 November 11:59 PM
	const checkMaintenanceTime = () => {
		const currentDate = new Date();

		// Define start time: 28 October, 12:01 AM
		const startTime = new Date();
		startTime.setFullYear(2024, 9, 28); // 9 = October, 28th day
		startTime.setHours(0, 1, 0, 0); // 00:01 = 12:01 AM

		// Define end time: 3 November, 11:59 PM
		const endTime = new Date();
		endTime.setFullYear(2024, 10, 3); // 10 = November, 3rd day
		endTime.setHours(2, 0, 0, 0); // 02:00 = 2:00 AM

		// Check if current time is between startTime and endTime
		if (currentDate >= startTime && currentDate <= endTime) {
			setShowMaintenanceBanner(true);
		} else {
			setShowMaintenanceBanner(false);
		}
	};

	useEffect(() => {
		// Run the check immediately
		checkMaintenanceTime();
		// Update every minute to reflect real-time changes
		const interval = setInterval(checkMaintenanceTime, 60000); // Check every minute
		return () => clearInterval(interval); // Cleanup the interval on component unmount
	}, []);

	const purchaseCreditsClickHandler = () => {
		history.push(`/e/${eventInfo.event_id}/credits`);
	}
	const isInternationalConditionTrue = isInternational &&
		!eventInfo?.allowed_payment_methods?.length &&
		isPaidEvent &&
		eventId;

	const isNotInternationalConditionTrue = eventId &&
		!isInternational &&
		isPaidEvent &&
		(!isBankDetailsAdded || !isKYCVerified || isSettlementsDisabled);

	return (
		<>
			{showMaintenanceBanner &&
				<MaintenanceBanner showMaintenanceBanner={showMaintenanceBanner} />}
			{isInternational &&
				!eventInfo?.allowed_payment_methods?.length &&
				isPaidEvent &&
				eventId && (
					<Banner
						isNotCreator={isNotCreator}
						eventId={eventInfo?.event_id}
						stripeConnect={true}

					/>
				)}
			{eventId &&
				!isInternational &&
				isPaidEvent &&
				(!isBankDetailsAdded || !isKYCVerified || isSettlementsDisabled) && (
					<Banner
						isNotCreator={isNotCreator}
						eventId={eventInfo?.event_id}
						isBankDetailsAdded={isBankDetailsAdded}
						isKYCVerified={isKYCVerified}
						isSettlementsDisabled={isSettlementsDisabled}
					/>
				)}


			<div className="d-flex align-items-center header-bg pl-5"></div>
			<div className={`row d-flex flex-column justify-content-center header w-100 ml-1  ${isManageEventsPage ? 'header-manage-accounts' : ''}`}>
				<div
					className={`p-0 d-flex justify-content-between ${!eventId ? "align-items-center" : ""} ${eventId ? "d-sm-block" : ""} `}
				>

					{!eventId && (
						<>
							{!expandedSection ? (<i
								className="fa fa-bars hamburger-menu-open mb-sm-3 white-color"
								aria-hidden="true"
								onClick={() => setExpandedSection(prev => !prev)}
							></i>) : (
								<img src={closeIcon} onClick={() => setExpandedSection(prev => !prev)} alt="closeicon" className="fa fa-bars hamburger-menu-close mb-sm-3 white-color" ></img>
							)}</>
					)}
					{!eventId && <AnimatedLogo isManageEventsPage={isManageEventsPage} color="white" />}
					{eventId && (
						<i
							className="fa fa-bars hamburger-menu mb-sm-3 white-color"
							aria-hidden="true"
							onClick={() => setSidebarIsOpen({ type: "toggle" })}
						></i>
					)}
					<div className="header__top text-right d-flex justify-content-lg-end justify-content-sm-center justify-content-center align-items-start">
						<MyCommunity
							ref={communityRef}
							onChildStateChange={handleCommunityStateChange}
							history={history}
						/>
						{eventId && (
							<>
								<div>
									<KonfhubButton
										style={{ background: "#fff", border: "1px solid #fff" }}
										btnType="secondary"
										className="position-relative"
										isLoading={isLoadStripeOrTap}
										onClick={() => {
											if (eventInfo?.event_plan !== 1 || isInternational || SuperAdmins.includes(props?.user?.attributes?.email)) {
												history.push(
													`${history.location.pathname}?plan=Lite`
												);
											}
										}}
										disabled={!SuperAdmins.includes(props?.user?.attributes?.email) && ((eventInfo?.event_plan === 1 && !isInternational) || eventDetails?.event_status === eventStatus.pastEvents)}
									>
										{planBtnContent()}
									</KonfhubButton>
								</div>
								<PricingPlanModal
									history={history}
									eventPlan={eventInfo?.event_plan}
									reloadApi={reloadApi}
									hasStripeOrTap={isInternational && hasStripeOrTap}
									isInternational={isInternational}
									eventId={eventDetails?.event_id}
									subscriptionPaymentId={eventInfo?.subscription_payment_id}
									props={props}
								/>
							</>
						)}

						<div className="">
							<TippyIcon content="Create New Event" placement="bottom">
								<span>
									<KonfhubButton
										className="px-3 ml-3"
										btnType="secondaryWhite"
										onClick={() => history.push("/create/event")}
									>
										<span className="create_new_event_mob_line_height ">
											<i className="fas fa-plus m-0 p-0"></i>
											<span className="create_new_event">&nbsp;&nbsp;&nbsp; </span> <span className="create_new_event">Create Event</span>
										</span>
									</KonfhubButton>
								</span>
							</TippyIcon>
						</div>
						{eventId && (
							<SwitchEventDropDown
								reloadApi={reloadApi}
								history={history}
								organiserDetails={organiserDetails}
								token={user.signInUserSession.accessToken.jwtToken}

							/>
						)}
						<WhatsNewPopup
							isManageEventsPage={isManageEventsPage}
							isInternationalConditionTrue={isInternationalConditionTrue}
							isNotInternationalConditionTrue={isNotInternationalConditionTrue}
						/>
						<SwitchApplications
							callCommunityFunction={callCommunityFunction}
							handleCommunityStateChange={handleCommunityStateChange}
							communityButtonLoading={communityButtonLoading}
							history={history}
							eventId={eventId}
							communityRef={communityRef}
						/>
						<ProfileDropDown
							profileImage={user.attributes["custom:profilePicture"]}
							email={user.attributes.email}
							name={user.attributes.name}
							attributes={user.attributes}
							history={history}
							eventId={eventId}
							callCommunityFunction={callCommunityFunction}
						/>
					</div>
				</div>
				{/* {!eventId && (
					<div className="text-center">
						<div className="manage_event_heading">Manage Events</div>
					</div>
				)} */}
				<div className="d-flex flex-column flex-sm-column flex-lg-row justify-content-between justify-content-sm-normal align-items-lg-end align-items-center">
					<div className="col-12 col-lg-8 custom-col-lg-7 p-0">
						{eventId && (
							<div className="d-flex justify-content-lg-start justify-content-sm-center justify-content-left ml-2 ml-lg-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2">
								<div className="header__title d-flex flex-wrap">
									<h2 className="h1-font white-color d-inline d-sm-block my-3">
										<span>{eventDetails?.name} </span>
										{/* <span className="ml-3 title-link-icon">
										<LinkPreviewIcon />
									</span>
									<span className="ml-3 title-view-icon">
										<CloneEventIcon />
									</span> */}
										<span className="live_mobile ml-2">
											{eventDetails?.event_status === 1 ? (
												<LiveStatusIcon className="event_status_icon" />
											) : eventDetails?.event_status === 2 ? (
												<UpcomingStatusIcon className="event_status_icon" />
											) : (
												<PastStatusIcon className="event_status_icon" />
											)}
										</span>
										<span className="ml-2 md-sm-3 title-icon">
											{/* <TippyIcon
												content="Preview Event Page"
												placement="bottom"
											>
												<a
													href={`${baseUrl}/${eventDetails?.event_url}`}
													target="_blank"
													rel="noreferrer"
												// title="Preview Event Page"
												>
													<LinkPreviewIcon className="preview_link_icon" />
												</a>
											</TippyIcon> */}
											<TippyIcon content="Clone Event" placement="bottom">
												<button
													className="ml-2 clone-btn"
													// title="Clone Event"
													onClick={() => {
														setOpenCloneModal(true);
													}}
												>
													<CloneEventIcon className="clone_event_icon" />
												</button>
											</TippyIcon>
											<TippyIcon content="Share Event" placement="bottom">
												<ShareQuickButton
													url={`${baseUrl}/${eventDetails?.event_url}`}
													className="ml-2 clone-btn"
													style={{ color: "#FFF" }}
													size="18px"
												/>
											</TippyIcon>
											<TippyIcon content="Preview Event Page" placement="bottom">
												<a
													href={`${baseUrl}/${eventDetails?.event_url}`}
													target="_blank"
													rel="noreferrer"
													className="view-event-page-link  d-sm-none"
												// title="Preview Event Page"
												>
													<LinkPreviewIcon className="preview_link_icon ml-2" />
												</a>
											</TippyIcon>
										</span>
									</h2>
								</div>
								{openShareModal && <div>
									<CustomModal
										width="320px"
										overflow={"scroll"}
										openModal={openShareModal}
										setOpenModal={setOpenShareModal}
										content={
											<>
												<ShareModal props={props} />
											</>
										}
									/>
								</div>}
								{/* <div className="header__short-btns d-flex flex-wrap">
									<button>+</button>
									<button>-</button>
									<button>=</button>
								</div> */}
							</div>
						)}

						{eventId && (
							<div className="white-color d-flex justify-content-lg-between justify-content-center mt-lg-0 mt-md-0 mt-sm-0 mt-0 mb-lg-0 mb-md-3 mb-sm-2 mb-2">
								<div className="event_status_isVirtual_type_timezone">
									<span className="live">
										{eventDetails?.event_status == 1 ? (
											<LiveStatusIcon />
										) : eventDetails?.event_status == 2 ? (
											<UpcomingStatusIcon />
										) : (
											<PastStatusIcon />
										)}
									</span>{" "}
									<TippyIcon content="Event Status" placement="bottom">
										<span className="pointer-cursor">
											{eventDetails?.event_status == 1
												? "Live"
												: eventDetails?.event_status == 2
													? "Upcoming"
													: "Past"}
										</span>
									</TippyIcon>{" "}
									|{" "}
									<TippyIcon content="Online/Offline Event" placement="bottom">
										<span className="pointer-cursor">
											{eventDetails?.is_virtual ? "Online" : "In-Person"}
										</span>
									</TippyIcon>{" "}
									|{" "}
									<TippyIcon content="Event Type" placement="bottom">
										<span className="pointer-cursor">
											{eventDetails?.is_free ? "Free" : "Paid"}
										</span>
									</TippyIcon>{" "}
									|
									<TippyIcon content="Event Timezone" placement="bottom">
										<span className="pointer-cursor">
											&nbsp;
											{moment
												.tz(props?.eventInfo?.time_zone)
												.format("z")
												.includes("+")
												? `GMT${moment.tz(props?.eventInfo?.time_zone).format("z")}`
												: `${moment.tz(props?.eventInfo?.time_zone).format("z")}`}
										</span>
									</TippyIcon>
									<TippyIcon content="Preview Event Page" placement="bottom">
										<a
											href={`${baseUrl}/${eventDetails?.event_url}`}
											target="_blank"
											rel="noreferrer"
											className="view-event-page-link "
										// title="Preview Event Page"
										>	<span className="view-event-page mr-2">View Event Page
												<LinkPreviewIcon className="preview_link_icon ml-2" />
											</span></a>
									</TippyIcon>
								</div>
								{/*<div className="quick-actions btn-group btn-group-sm row d-xl-flex d-lg-flex d-md-flex d-sm-none d-none">
									<TippyIcon content="Attendees" placement="bottom">
										<button className="btn px-3">
											<AttendeesIcon
												onClick={() =>
													history.push(`/e/${eventDetails?.event_id}/attendees`)
												}
											/>
										</button>
									</TippyIcon>
									<TippyIcon content="Create New Coupon" placement="bottom">
										<button className="btn px-3 btn-border">
											<NewCouponIcon
												onClick={() =>
													history.push(
														`/e/${eventDetails?.event_id}/eventInfo/coupons/add-coupon`,
													)
												}
											/>
										</button>
									</TippyIcon>
									<TippyIcon content="Create New Ticket" placement="bottom">
										<button className="btn px-3">
											<NewTicketIcon
												onClick={() =>
													history.push(
														`/e/${eventDetails?.event_id}/eventInfo/ticketsnforms/tickets/add-ticket`,
													)
												}
											/>
										</button>
									</TippyIcon>
								</div>*/}
							</div>
						)}

						{/* Show this div only for mobile */}
						{/* <div className="col-sm-4 col-7 mx-auto quick-actions btn-group btn-group-sm d-lg-none d-md-none d-sm-block mt-lg-0 mt-md-0 mt-sm-2 mt-2 mb-lg-0 mb-md-0 mb-sm-2 mb-2 quick-actions-mobile">
							<TippyIcon content="View Attendees" placement="bottom">
								<button className="btn px-3">
									<AttendeesIcon
										onClick={() =>
											history.push(`/e/${eventDetails?.event_id}/attendees`)
										}
									/>
								</button>
							</TippyIcon>
							<TippyIcon content="Create New Coupon" placement="bottom">
								<button className="btn px-3 btn-border">
									<NewCouponIcon
										onClick={() =>
											history.push(
												`/e/${localStorage.getItem(
													"eventId"
												)}/eventInfo/coupons/add-coupon`
											)
										}
									/>
								</button>
							</TippyIcon>
							<TippyIcon content="Create New Ticket" placement="bottom">
								<button className="btn px-3">
									<NewTicketIcon
										onClick={() =>
											history.push(
												`/e/${localStorage.getItem(
													"eventId"
												)}/eventInfo/ticketsnforms/tickets/add-ticket`
											)
										}
									/>
								</button>
							</TippyIcon>
						</div> */}
					</div>
					<div className="ml-lg-auto ml-0">
						<EventLimits
							eventDetails={props?.eventInfo}
							participantCount={eventDetails?.attendees_count}
							isInternational={isInternational}
							max_regs_count={props.eventInfo?.max_regs_count}
							purchaseCreditsClickHandler={purchaseCreditsClickHandler}
						/>
					</div>
				</div>
			</div>

			{openCloneModal && (
				<CloneEventModal
					openCloneModal={openCloneModal}
					setOpenCloneModal={setOpenCloneModal}
					eventDetails={eventInfo}
				/>
			)}

			<style>{`
                .live svg {
                    margin-bottom: 2px;
                }
                .title-view-icon svg {
                    width: 30px;
                    height: 20px;
                }
				.clone-btn {
					border: none;
					background: transparent;
				}
				.quick-actions{
					background:white;
					margin-right:30px;
					margin-top:-15px;
					border-radius:3px;
				}
				.quick-actions .btn{
					box-shadow:none;
				}
				.btn-border{
					border-left: 1px solid #6D7780 !important;
					border-right: 1px solid #6D7780 !important;
					border-radius: 0px !important;
				}
				.clone-info {
					border-radius: 5px;
					border: 1px solid #E2E2E2;
					background: #F8F8F8;
					color: #6C757D;
					font-size: 14px;
					font-weight: 400;
				}
				.manage_event_heading {
					font-size: 30px;
					font-weight: 600;
					line-height: 48.03px;
					color: #fff;
				}
				.konfhub_white_logo_header {
					margin-bottom: -62px !important;
				}
				.view-event-page{
					border: 1px solid #FFFFFF;
					padding: 2px 10px;
					margin:0 5px;
					border-radius: 20px;
					cursor: pointer;
				}
				.view-event-page-link{
					color:#fff;
				}
				.view-event-page-link:hover{
					text-decoration:none;
					color:#fff;
				}
				
				@media (max-width: 426px){
					.konfhub_white_logo_header {
						margin-bottom: -2px !important;
					}
				}
				@media (min-width: 1069px) and (max-width: 1179px) {
					.custom-col-lg-7 {
						flex: 0 0 auto;
						width: 58.33333333%;
					}
				}
            `}</style>
		</>
	);
};

export default Header;
